import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { throwIfAlreadyLoaded } from '../guards/module-import.guard';

@NgModule({
    imports: [
        CommonModule
    ],
    exports: [],
    declarations: [],
})
export class InterceptorsModule {
    constructor(@Optional() @SkipSelf() parentModule: InterceptorsModule) {
        throwIfAlreadyLoaded(parentModule, 'InterceptorsModule');
    }
    static forRoot(environment: any): ModuleWithProviders<InterceptorsModule> {
        return {
            ngModule: InterceptorsModule,
            providers: [],
        };
    }
}